import useDictionary from "redux/dictionary/useDictionary";

export const AspectRatioName = ({ value }: { value: string }) => {
  const [aspectRatioDictionary] = useDictionary("aspect-ratio");

  const ratio = aspectRatioDictionary.find((ratio) => ratio?.id === value);

  return <span>{ratio?.title ?? value}</span>;
};
